import { Reducer } from 'redux';
import {
  NewLongSteelOrdersOnboardingState,
  NewLongSteelOrdersOnboardingSteps,
  NewLongSteelOrdersOnboardingTypes
} from './types';

const INITIAL_STATE: NewLongSteelOrdersOnboardingState = {
  step: NewLongSteelOrdersOnboardingSteps.INITIAL,
  loading: false,
  error: false
};

type TCustomAction = {
  type: NewLongSteelOrdersOnboardingTypes;
  payload: {
    step: NewLongSteelOrdersOnboardingSteps;

    customerId: string;
  };
};

const reducer: Reducer<NewLongSteelOrdersOnboardingState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case NewLongSteelOrdersOnboardingTypes.START:
      return {
        ...state,
        step: NewLongSteelOrdersOnboardingSteps.INITIAL,
        loading: false,
        error: false
      };

    case NewLongSteelOrdersOnboardingTypes.NEXT_STEP:
      return {
        ...state,
        step: NewLongSteelOrdersOnboardingSteps.NEXT_STEP,
        loading: false,
        error: false
      };

    case NewLongSteelOrdersOnboardingTypes.FINISHED:
      return {
        ...state,
        step: NewLongSteelOrdersOnboardingSteps.FINISHED,
        loading: false,
        error: false
      };

    default:
      return state;
  }
};

export default reducer;
